import { render, staticRenderFns } from "./whitelistip.vue?vue&type=template&id=76a937d1&"
import script from "./whitelistip.vue?vue&type=script&lang=js&"
export * from "./whitelistip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports